// Cabin metadata + photos (URLs from /public/cabins/*)
export const CABINS = [
  {
    id: "domo-01",
    name: "Domo - 01",
    daily_rate: 1030.0,
    tagline: "Domo geodésico romântico com vista para o lago.",
    description:
      "Bem-vindo a este encantador Domo, cuidadosamente projetado para proporcionar um refúgio tranquilo e romântico. Localizado em uma colina, oferece vistas panorâmicas do lago e das montanhas. As grandes janelas convidam a luz natural a iluminar o ambiente.",
    amenities: [
      "Design geodésico único",
      "Na beira da água",
      "Área gourmet com parrilla argentina e chopeira",
      "Jacuzzi privativa",
      "Wi-Fi",
      "Câmeras de segurança externas",
      "Permitido animais",
      "Ar-condicionado split",
      "Cama Queen flutuante",
      "Redário",
      "Amplo jardim e paisagismo",
      "Vista para o Lago",
    ],
    photos: [
      "/cabins/domo-01/0823ae4b-8ec6-4809-8166-a8579a3ded2d.avif",
      "/cabins/domo-01/0c2fa25a-98c6-491d-824b-f1b8a2984c1a.avif",
      "/cabins/domo-01/1e0fcbc4-eef8-4689-95dd-2481964083b1.avif",
      "/cabins/domo-01/264a5db2-74cb-4104-ac4d-130526584636.avif",
      "/cabins/domo-01/443f7093-c879-476a-9961-fb8a583f94f3.avif",
      "/cabins/domo-01/880fc759-a3d4-4487-9f1f-42148679d8b5.avif",
      "/cabins/domo-01/db6342ff-1c71-4ddf-bf40-4f1d80231fb8.avif",
      "/cabins/domo-01/ddbc9b49-5750-4263-847c-85a5cb3d81b7.avif",
      "/cabins/domo-01/e1ebb48c-2739-4699-9b75-b8f2a69f53ae.avif",
    ],
  },
  {
    id: "domo-02",
    name: "Domo - 02",
    daily_rate: 1030.0,
    tagline: "Domo geodésico aconchegante na beira do lago.",
    description:
      "Bem-vindo a este encantador Domo, cuidadosamente projetado para proporcionar um refúgio tranquilo e romântico. Localizado em uma colina, oferece vistas panorâmicas do lago e das montanhas. As grandes janelas convidam a luz natural a iluminar o ambiente.",
    amenities: [
      "Design geodésico único",
      "Na beira da água",
      "Área gourmet com parrilla argentina e chopeira",
      "Jacuzzi privativa",
      "Wi-Fi",
      "Câmeras de segurança externas",
      "Permitido animais",
      "Ar-condicionado split",
      "Cama Queen flutuante",
      "Redário",
      "Amplo jardim e paisagismo",
      "Vista para o Lago",
    ],
    photos: [
      "/cabins/domo-02/59313e05-04c5-44dd-8787-4e170258f80f.avif",
      "/cabins/domo-02/6dade7c3-34d2-4a67-ba69-d86315e8000a.avif",
      "/cabins/domo-02/71ef8bad-0ebd-413e-93fb-ae342ac04382.avif",
      "/cabins/domo-02/94ecf984-8a6b-4846-9705-516351b81400.avif",
      "/cabins/domo-02/ab1cb532-4221-4fbd-a93c-1a3c7e7c1310.avif",
      "/cabins/domo-02/b3ba6f02-6236-4729-b6de-bc39125ae01d.avif",
      "/cabins/domo-02/b55c7c75-d3a2-4365-a4f6-cbad3a8189cd.avif",
      "/cabins/domo-02/ddbe9ac8-9048-4bd8-8b5f-fbf549e1a80d.avif",
      "/cabins/domo-02/ebe1d91f-8ed9-4dd4-b107-752edc1e5a44.avif",
      "/cabins/domo-02/f0722c68-de2f-439f-96c5-8015273708df.avif",
    ],
  },
  {
    id: "container",
    name: "Container do Lago",
    daily_rate: 950.0,
    tagline: "Container exclusivo de frente para a represa com acesso privativo ao lago.",
    description:
      "Bem-vindo a este encantador Container, cuidadosamente projetado para proporcionar um refúgio tranquilo e romântico. Localizado de frente à represa, com acesso privativo ao Lago e vistas panorâmicas das montanhas. As grandes portas convidam a luz natural a iluminar o ambiente.",
    amenities: [
      "Design único",
      "Na beira da água",
      "Área gourmet com parrilla argentina e chopeira",
      "Jacuzzi privativa",
      "Wi-Fi",
      "Câmeras de segurança externas",
      "Permitido animais",
      "Ar-condicionado split",
      "Cama Queen flutuante",
      "Redário",
      "Amplo jardim e paisagismo",
      "Vista para o Lago",
    ],
    photos: [
      "/cabins/container/261470db-37f3-483a-b495-ed018a390980.avif",
      "/cabins/container/4383fb2a-6701-41fb-8c78-ac8b9ede64a5.avif",
      "/cabins/container/532b8535-0bd7-4186-835b-4e8457c4e15e.avif",
      "/cabins/container/7dbe7de2-ba1b-48fc-b999-95526f9f8fcf.avif",
      "/cabins/container/85964587-5919-4a45-8fad-c084bf83e24a.avif",
      "/cabins/container/9e9040d0-7767-4cad-9e3d-d45564237458.avif",
      "/cabins/container/a301ed94-e25a-4a4e-bfc1-e13838cba74c.avif",
      "/cabins/container/a434fe78-82fb-4e93-bf07-d5a5e07a4d3e.avif",
      "/cabins/container/a8d86960-c4cb-443f-971b-e809c5fd145a.avif",
      "/cabins/container/f1bb2cd1-b0b9-44de-9656-94a17d2cc004.avif",
    ],
  },
];

export const PET_FEE = 200.0;

export const PAYMENT_OPTIONS = [
  { value: "pix", label: "Pix" },
  { value: "credit_1x", label: "Cartão de Crédito - 1x sem juros" },
  { value: "credit_2x", label: "Cartão de Crédito - 2x sem juros" },
  { value: "credit_3x", label: "Cartão de Crédito - 3x sem juros" },
  { value: "credit_4x", label: "Cartão de Crédito - 4x sem juros" },
  { value: "credit_5x", label: "Cartão de Crédito - 5x sem juros" },
  { value: "credit_6x", label: "Cartão de Crédito - 6x sem juros" },
];

export const FAQ_ITEMS = [
  {
    q: "Posso levar meu pet?",
    a: "Sim! Somos pet friendly. Cobramos uma taxa de R$ 200,00 para higienização do espaço após a hospedagem com animais de estimação.",
  },
  {
    q: "Algo incluso na acomodação?",
    a: "Sim! Café da manhã e jantar estão inclusos na acomodação.",
  },
  {
    q: "Onde fica localizado?",
    a: "Estamos localizados em Igaratá/SP, em uma área afastada e cercada de natureza, próxima da represa do Jaguari.",
  },
  {
    q: "Qual o horário de Check-in?",
    a: "Check-in a partir das 12:00 horas.",
  },
  {
    q: "Qual o horário de Check-out?",
    a: "Check-out até as 16:00 horas.",
  },
];

export const CONTACT = {
  name: "Cabanas Igaratá",
  address: "Estrada das VIPS, Igaratá - SP, 12350-000",
  phone: "(11) 98322-2264",
  phoneRaw: "5511983222264",
  email: "reservascabanasigarata@gmail.com",
  cnpj: "62.678.627/0001-53",
};
